import React from 'react';
import { useTranslation } from 'react-i18next';
import { Plan, Session, useRecruitment } from '@app/api';
import { useRelevantPlanProducts } from 'lib/planAndOffer';
import { PriceDetails } from './PriceDetails';
import { usePlanPriceTotal } from 'lib/priceComputation';

interface Props {
  plan: Plan;
  session: Session;
  className?: string;
  totalOnly?: boolean;
  applyVat?: boolean;
  noTooltip?: boolean;
  defaultOpened?: boolean;
}

export const PlanPriceDetails = ({
  className,
  plan,
  session,
  totalOnly,
  applyVat,
  noTooltip,
  defaultOpened = true,
}: Props) => {
  const { t } = useTranslation();
  const { data: recruitment } = useRecruitment(session.recruitmentId);

  const products = useRelevantPlanProducts(
    plan.id,
    session.id,
    recruitment?.countryKeys,
  );
  const totals = usePlanPriceTotal(session, plan, applyVat);

  return (
    <PriceDetails
      products={products}
      countryKeys={recruitment?.countryKeys}
      duration={session.duration}
      numberOfParticipants={session.numberOfParticipantRequired}
      className={className}
      totalOnly={totalOnly}
      tooltip={noTooltip ? undefined : t('billing.studyPrice.tooltip')}
      defaultOpened={defaultOpened}
      totals={totals}
    />
  );
};
